export const pannable = element => {
	
	/** @type {Number} */
	let x;

	/** @type {Number} */
	let y;

	/** @type {Number} */
	let activeTouchIdentifier;

	/**
	 * Send a custom event 
	 * @param {String} eventName - Name of the event to fire
	 * @param {Object} detail - Data to add to event.detail
	 */
	const notify = (eventName, detail) => {
		element.dispatchEvent(new CustomEvent(eventName, { detail }));
	}

	/**
	 * Consume a `touchstart` event and notify of a pan start
	 * @param {TouchEvent} event - The DOM event
	 */
	const handleTouchStart = event => {
		if (!activeTouchIdentifier) {
			const touch = event.touches[0];
			activeTouchIdentifier = touch.identifier;
			x = touch.clientX;
			y = touch.clientY;
			notify('panstart', { x, y });
			window.addEventListener('touchmove', handleTouchMove);
			window.addEventListener('touchend', handleTouchEnd);
		}
		event.preventDefault();
	}

	/**
	 * Consume `touchmove` events and notify of a pan in progress
	 * @param {TouchEvent} event - The DOM event
	 */
	 const handleTouchMove = event => {
		const { changedTouches } = event;
		for (let c = 0; c < changedTouches.length; c++) {
			if (changedTouches[c].identifier === activeTouchIdentifier) {
				const touch = changedTouches[c];
				const dx = touch.clientX - x;
				const dy = touch.clientY - y;
				x = touch.clientX;
				y = touch.clientY;
				notify('panmove', { x, y, dx, dy });
			}
		}
	}

	/**
	 * Consume a `touchend` event and notify of a pan end
	 * @param {TouchEvent} event - The DOM event
	 */
	 const handleTouchEnd = event => {
		const { changedTouches } = event;
		for (let c = 0; c < changedTouches.length; c++) {
			if (changedTouches[c].identifier === activeTouchIdentifier) {
				notify('panend', { x, y });
				window.removeEventListener('touchmove', handleTouchMove);
				window.removeEventListener('touchend', handleTouchEnd);
				activeTouchIdentifier = null;
			}
		}
	}

	/**
	 * Consume a `touchcancel` event and resets the pan
	 * @param {TouchEvent} event - The DOM event
	 */
	const handleTouchCancel = () => {
		activeTouchIdentifier = null;
		window.removeEventListener('touchmove', handleTouchMove);
		window.removeEventListener('touchend', handleTouchEnd);
		notify('panend', { x, y });
	}

	/**
	 * Consume a mousedown event and notify of a pan start
	 * @param {MouseEvent} event - The DOM event
	 */
	const handleMouseDown = event => {
		x = event.clientX;
		y = event.clientY;
		notify('panstart', { x, y });
		window.addEventListener('mousemove', handleMouseMove);
		window.addEventListener('mouseup', handleMouseUp);
		event.preventDefault();
	}

	/**
	 * Consume mousemove events and notify of a pan in progress
	 * @param {MouseEvent} event - The DOM event
	 */
	const handleMouseMove = event => {
		//console.log(event)
		const dx = event.clientX - x;
		const dy = event.clientY - y;
		x = event.clientX;
		y = event.clientY;
		notify('panmove', { x, y, dx, dy });
	}

	/**
	 * Consume a mouseup event and notify of a pan end
	 * @param {MouseEvent} event - The DOM event
	 */
	const handleMouseUp = event => {
		x = event.clientX;
		y = event.clientY;
		notify('panend', { x, y });
		window.removeEventListener('mousemove', handleMouseMove);
		window.removeEventListener('mouseup', handleMouseUp);
	}

	element.addEventListener('mousedown', handleMouseDown);
	element.addEventListener('touchstart', handleTouchStart);
	element.addEventListener('touchcancel', handleTouchCancel);

	return {
		destroy() {
			element.removeEventListener('mousedown', handleMouseDown);
			element.removeEventListener('touchstart', handleTouchStart);
		}
	};
}
